import { Project } from '@vincerosoft/assessfluence-types';
import { FirebaseApp } from 'firebase/app';
import { Auth } from 'firebase/auth';
import { Firestore } from 'firebase/firestore';
import { Functions } from 'firebase/functions';
import { FirebaseStorage } from 'firebase/storage';
import { createStoreWithSelector } from '../../utils/zustand/createStoreWithSelector';
import { createUseStore } from '../../utils/zustand/createUseStore';

type State = {
  project: Project | null;
  app: FirebaseApp | null;
  auth: Auth | null;
  db: Firestore | null;
  storage: FirebaseStorage | null;
  functions: Functions | null;
  isInitialized: boolean;
};

type Actions = {
  setProject: (project: Project | null) => void;
  setApp: (app: FirebaseApp | null) => void;
  setAuth: (auth: Auth | null) => void;
  setDb: (db: Firestore | null) => void;
  setStorage: (storage: FirebaseStorage | null) => void;
  setFunctions: (functions: Functions | null) => void;
  setIsInitialized: (isInitialized: boolean) => void;
};

const initialValue = {
  project: null,
  app: null,
  auth: null,
  db: null,
  storage: null,
  functions: null,
  isInitialized: false
};

export const coreAppStore = createStoreWithSelector<State & Actions>()((set) => ({
  ...initialValue,
  setProject: (project) => set({ project }),
  setApp: (app) => set({ app }),
  setAuth: (auth) => set({ auth }),
  setDb: (db) => set({ db }),
  setStorage: (storage) => set({ storage }),
  setFunctions: (functions) => set({ functions }),
  setIsInitialized: (isInitialized) => set({ isInitialized })
}));

export const useCoreAppStore = createUseStore(coreAppStore);
